/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Portal, TemplatePortal } from '@angular/cdk/portal';
import {
  ContentChild,
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { defer, isNil, noop } from 'lodash';
import { TabOptionsDirective } from './tab-options.directive';

export const TAB_RENDER_STRATEGY_LAZY = 'lazy';
export const TAB_RENDER_STRATEGY_EAGER = 'eager';
export const TAB_RENDER_STRATEGY_ALWAYS = 'always';
export type TabRenderStrategy = 'lazy' | 'eager' | 'always';

@Directive({
  standalone: false,
  selector: '[ghTabContent]',
})
export class TabContentDirective extends TemplatePortal<any> {
  constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
}

@Directive({
  standalone: false,
  selector: 'gh-tab',
})
export class TabDirective implements OnInit {
  @Input() name: string;
  @Input() label: string;
  @Input('render') renderStrategy: TabRenderStrategy = TAB_RENDER_STRATEGY_LAZY;

  @ContentChild(TabContentDirective, { static: false }) portal: Portal<any>;

  optionsPortal?: TabOptionsDirective;

  private onChange: () => void = noop;
  private _renderedOnce = false;

  get renderedOnce(): boolean {
    return this._renderedOnce;
  }

  ngOnInit(): void {
    if (isNil(this.name)) {
      throw new Error('Tab name MUST BE defined');
    }
  }

  setOptionsPortal(portal?: TabOptionsDirective): void {
    // defer is necessary to avoid ExpressionChangedAfterItHasBeenCheckedError
    defer(() => {
      this.optionsPortal = portal;
      this.onChange();
    });
  }

  setRenderedOnce(): void {
    this._renderedOnce = true;
  }

  registerOnChange(onChange: () => void): void {
    this.onChange = onChange;
  }
}
